import { AppBar, Toolbar, Typography } from "@mui/material";
import { COLORS } from "components";
import React from "react";

interface InfoMessageBarProps {
    sx?: React.CSSProperties;
    children: React.ReactNode;
}

export const InfoMessageBar: React.FC<InfoMessageBarProps> = ({ children, sx }) => (
    <AppBar
        position="static"
        sx={{
            backgroundColor: COLORS.Romance,
            height: "23px",
            top: "auto",
            bottom: 0,
            textAlign: "center",
            width: "100%",
            ...sx,
        }}
    >
        <Toolbar
            sx={{
                color: "white",
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "fit-content !important",
            }}
        >
            <Typography align="center">
                {children}
            </Typography>
        </Toolbar>
    </AppBar>)
